export default __webpack_public_path__ + "static/media/pilz-10.14ea22f0.png";